const YouTubeVideo = ({ videoUrl, style }) => {
  return (
    <div className='videoContainer' style={style}>
      <iframe
        width="560"
        height="315"
        style={{ borderRadius: '10px' }}
        src={videoUrl}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />

      <style jsx>{`
        .videoContainer {
          position: relative;
          padding-bottom: 56.25%; /* 16:9 */
          height: 0;
          width: 100%;
        }
        
        .videoContainer iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      `}</style>
    </div>
  );
};

export default YouTubeVideo;